import axios from 'axios';
import { Photo, UploadCredits, UploadPhotoPayload } from '../types';
import { attachAuthInterceptor } from './authToken';

const BASE_URL = process.env.REACT_APP_CLUBHOUSE_API_URL || 'http://localhost:5000';

const apiClient = axios.create({
  baseURL: `${BASE_URL}/api`,
});
attachAuthInterceptor(apiClient);

export const photoApi = {
  getAll: async (user?: string): Promise<Photo[]> => {
    const { data } = await apiClient.get<Photo[]>('/photos', {
      params: user ? { user } : undefined,
    });
    return data;
  },

  getById: async (id: string): Promise<Photo> => {
    const { data } = await apiClient.get<Photo>(`/photos/${id}`);
    return data;
  },

  /** The signed-in golfer's remaining Caddie Credits balance. */
  getCredits: async (user: string): Promise<UploadCredits> => {
    const { data } = await apiClient.get<UploadCredits>('/photos/credits', { params: { user } });
    return data;
  },

  upload: async (payload: UploadPhotoPayload): Promise<Photo> => {
    const formData = new FormData();
    formData.append('file', payload.file);
    formData.append('description', payload.description);
    if (payload.user) formData.append('user', payload.user);
    if (payload.latitude !== undefined) formData.append('latitude', String(payload.latitude));
    if (payload.longitude !== undefined) formData.append('longitude', String(payload.longitude));
    if (payload.courseName) formData.append('courseName', payload.courseName);
    if (payload.courseId !== undefined) formData.append('courseId', String(payload.courseId));
    if (payload.holeNumber !== undefined) formData.append('holeNumber', String(payload.holeNumber));
    if (payload.distanceToHoleYards !== undefined)
      formData.append('distanceToHoleYards', String(payload.distanceToHoleYards));

    const { data } = await apiClient.post<Photo>('/photos/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return data;
  },

  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`/photos/${id}`);
  },

  analyze: async (id: string): Promise<Photo> => {
    const { data } = await apiClient.post<Photo>(`/photos/${id}/analyze`);
    return data;
  },

  getSpeech: async (id: string): Promise<Blob> => {
    const { data } = await apiClient.get<Blob>(`/photos/${id}/speech`, { responseType: 'blob' });
    return data;
  },
};
